<template>
  <div v-if="isDemo">
    <!-- Shiriti i vazhdueshem: e mban te qarte se ku ndodhet vizitori -->
    <div class="demo-banner" :class="{ 'demo-banner--mbi-shirit': mbiShirit }">
      <div class="demo-banner__inner">
      <span class="demo-banner__text">
        <v-icon size="16" color="white" class="mr-1">mdi-flask-outline</v-icon>
        {{ $t('demo.banner') }}
        <span v-if="secondsLeft !== null && !identified" class="demo-banner__timer">
          {{ $t('demo.time_left') }} {{ countdown }}
        </span>
      </span>
      <v-btn x-small depressed class="demo-banner__exit" @click="exitDemo">
        <v-icon size="14" left>mdi-logout</v-icon>
        {{ $t('demo.exit') }}
      </v-btn>
      </div>
    </div>

    <!-- Njoftimi qe del nje here pas hyrjes -->
    <v-dialog v-model="showNotice" max-width="460" persistent>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon color="primary" class="mr-2">mdi-flask-outline</v-icon>
          {{ $t('demo.welcome_title') }}
        </v-card-title>

        <v-card-text>
          <p class="mb-3">
            {{ $t(introKey) }}
          </p>

          <v-alert dense text type="warning" class="mb-3">
            {{ $t('demo.welcome_warning_1') }}
            <strong>{{ $t('demo.welcome_warning_2') }}</strong
            >, {{ $t('demo.welcome_warning_3') }}
          </v-alert>

          <p class="text-caption grey--text mb-0">
            {{ $t('demo.welcome_note') }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" depressed @click="dismiss">{{ $t('demo.understood') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Pas kohes se lire: te dhenat + verifikimi i email-it. Nuk mbyllet
         pa u verifikuar; serveri gjithsesi refuzon kerkesat deri atehere. -->
    <v-dialog v-model="showGate" max-width="480" persistent no-click-animation>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon color="primary" class="mr-2">mdi-email-check-outline</v-icon>
          {{ step === 'form' ? $t('demo.gate_title') : $t('demo.gate_code_title') }}
        </v-card-title>

        <!-- Hapi 1: te dhenat -->
        <v-card-text v-if="step === 'form'">
          <p class="mb-4">{{ $t('demo.gate_intro') }}</p>

          <v-form ref="gateForm" v-model="formValid" @submit.prevent="submitLead">
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model.trim="form.name"
                  :label="$t('demo.first_name')"
                  :rules="[rules.required, rules.min2]"
                  :error-messages="fieldError('name')"
                  outlined dense autofocus
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model.trim="form.last_name"
                  :label="$t('demo.last_name')"
                  :rules="[rules.required, rules.min2]"
                  :error-messages="fieldError('last_name')"
                  outlined dense
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model.trim="form.phone"
                  :label="$t('demo.phone')"
                  :rules="[rules.required, rules.phone]"
                  :error-messages="fieldError('phone')"
                  type="tel" outlined dense
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model.trim="form.email"
                  :label="$t('demo.email')"
                  :rules="[rules.required, rules.email]"
                  :error-messages="fieldError('email')"
                  :hint="$t('demo.email_hint')"
                  persistent-hint
                  type="email" outlined dense
                />
              </v-col>
            </v-row>
          </v-form>

          <v-alert v-if="generalError" dense text type="error" class="mt-2 mb-0">{{ generalError }}</v-alert>
        </v-card-text>

        <!-- Hapi 2: kodi nga email-i -->
        <v-card-text v-else>
          <p class="mb-1">{{ $t('demo.gate_code_intro') }}</p>
          <p class="font-weight-semibold mb-4">{{ form.email }}</p>

          <v-form @submit.prevent="submitCode">
            <v-text-field
              v-model.trim="code"
              :label="$t('demo.code')"
              :error-messages="fieldError('code')"
              inputmode="numeric" maxlength="6" autocomplete="one-time-code"
              class="demo-code-input"
              outlined autofocus
              @input="clearErrors"
            />
          </v-form>

          <div class="d-flex flex-wrap align-center justify-space-between">
            <v-btn text small color="primary" :disabled="resendIn > 0 || busy" @click="resendCode">
              <v-icon size="16" left>mdi-email-sync-outline</v-icon>
              {{ resendIn > 0 ? $t('demo.resend_in', { s: resendIn }) : $t('demo.resend') }}
            </v-btn>
            <v-btn text small :disabled="busy" @click="editData">
              <v-icon size="16" left>mdi-pencil-outline</v-icon>
              {{ $t('demo.edit_data') }}
            </v-btn>
          </div>

          <v-alert v-if="generalError" dense text type="error" class="mt-2 mb-0">{{ generalError }}</v-alert>
          <v-alert v-if="info" dense text type="success" class="mt-2 mb-0">{{ info }}</v-alert>
        </v-card-text>

        <v-card-actions>
          <v-btn text :disabled="busy" @click="exitDemo">{{ $t('demo.exit') }}</v-btn>
          <v-spacer />
          <v-btn
            v-if="step === 'form'"
            color="primary" depressed :loading="busy" :disabled="!formValid"
            @click="submitLead"
          >
            {{ $t('demo.send_code') }}
          </v-btn>
          <v-btn
            v-else
            color="primary" depressed :loading="busy" :disabled="code.length !== 6"
            @click="submitCode"
          >
            {{ $t('demo.verify') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/**
 * Shfaqet vetem per llogarite demo. Per perdoruesit realë nuk rrezaton asgje —
 * `isDemo` lexohet nga localStorage, i vendosur vetem nga AuthService.demoLogin.
 */
import axios from 'axios';

/** Sa shpesh pyetet serveri per gjendjen e numeratorit (ms). */
const STATUS_POLL_MS = 20000;

export default {
  name: 'DemoBanner',

  data() {
    return {
      showNotice: false,
      // Vetem pamja e prindit dhe e nxenesit kane shirit navigimi poshte.
      mbiShirit: false,

      // Numeratori i kohes se lire dhe dritarja e te dhenave.
      secondsLeft: null,
      identified: localStorage.getItem('demo_identified') === '1',
      showGate: false,
      step: 'form',
      formValid: false,
      busy: false,
      form: { name: '', last_name: '', phone: '', email: '' },
      code: '',
      resendIn: 0,
      errors: {},
      generalError: '',
      info: '',
      timers: { tick: null, poll: null, resend: null },

      rules: {
        required: (v) => !!v || this.$t('demo.rule_required'),
        min2: (v) => (v && v.length >= 2) || this.$t('demo.rule_min2'),
        phone: (v) => /^[+\d][\d\s().-]{5,}$/.test(v || '') || this.$t('demo.rule_phone'),
        email: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v || '') || this.$t('demo.rule_email'),
      },
    };
  },

  computed: {
    isDemo() {
      return localStorage.getItem('demo_mode') === '1';
    },

    /** Hyrja ndryshon sipas rolit me te cilin u hy ne demo. */
    introKey() {
      const rol = localStorage.getItem('userRole');
      if (rol === '1') return 'demo.intro_organisation';
      if (rol === '2' || rol === '7') return 'demo.intro_school';
      if (rol === '3') return 'demo.intro_driver';
      if (rol === '6') return 'demo.intro_student';
      return 'demo.intro_parent';
    },

    countdown() {
      const s = Math.max(0, this.secondsLeft || 0);
      const m = Math.floor(s / 60);
      const r = s % 60;
      return `${m}:${r < 10 ? '0' : ''}${r}`;
    },
  },

  mounted() {
    if (this.isDemo && localStorage.getItem('demo_notice_pending') === '1') {
      this.showNotice = true;
    }

    if (this.isDemo && !this.identified) {
      window.addEventListener('demo-lead-required', this.openGate);
      this.fetchStatus();
      this.timers.poll = setInterval(this.fetchStatus, STATUS_POLL_MS);
      this.timers.tick = setInterval(this.tick, 1000);
    }

    // Shiriti i navigimit shfaqet vetem ne disa pamje dhe vetem ne telefon;
    // ngrihemi mbi te vetem kur ekziston vertet, qe te mos mbetet hapesire
    // bosh atje ku nuk ka.
    this.$nextTick(() => {
      this.mbiShirit = !!document.querySelector('.parent-bottom-bar, .sbn-bar');
      if (!this.isDemo) return;
      document.body.classList.add('ka-shirit-demo');
      document.body.classList.toggle('ka-shirit-nav', this.mbiShirit);
    });
  },

  beforeDestroy() {
    document.body.classList.remove('ka-shirit-demo', 'ka-shirit-nav');
    this.stopTimers();
  },

  methods: {
    dismiss() {
      this.showNotice = false;
      localStorage.removeItem('demo_notice_pending');
    },

    stopTimers() {
      window.removeEventListener('demo-lead-required', this.openGate);
      Object.keys(this.timers).forEach((k) => {
        clearInterval(this.timers[k]);
        this.timers[k] = null;
      });
    },

    /** Gjendja vjen nga serveri: rifreskimi i faqes nuk e rinis numeratorin. */
    async fetchStatus() {
      try {
        const { data } = await axios.get('/auth/demo/status');

        if (data.identified) {
          this.markIdentified();
          return;
        }

        this.secondsLeft = data.seconds_left;

        if (data.pending_verification) {
          this.form.email = data.email || this.form.email;
          this.step = 'code';
          this.startResendCountdown(data.resend_in || 0);
        }

        if (data.required) this.openGate();
      } catch (e) {
        // Nje deshtim i perkohshem nuk duhet ta prishe demon; serveri
        // gjithsesi e zbaton kufirin dhe interceptor-i e hap dritaren.
      }
    },

    tick() {
      if (this.secondsLeft === null || this.identified) return;
      if (this.secondsLeft > 0) {
        this.secondsLeft -= 1;
      } else if (!this.showGate) {
        this.openGate();
      }
    },

    openGate() {
      if (this.identified) return;
      this.showNotice = false;
      this.showGate = true;
    },

    markIdentified() {
      this.identified = true;
      this.showGate = false;
      this.secondsLeft = null;
      localStorage.setItem('demo_identified', '1');
      this.stopTimers();
    },

    fieldError(field) {
      const e = this.errors[field];
      return e ? (Array.isArray(e) ? e[0] : e) : '';
    },

    clearErrors() {
      this.errors = {};
      this.generalError = '';
      this.info = '';
    },

    applyError(err) {
      const data = err?.response?.data || {};
      this.errors = data.errors || {};
      if (this.errors.demo) {
        this.generalError = this.errors.demo[0];
      } else if (!Object.keys(this.errors).length) {
        this.generalError = data.message || this.$t('demo.error_generic');
      }
      if (data.resend_in) this.startResendCountdown(data.resend_in);
    },

    startResendCountdown(seconds) {
      clearInterval(this.timers.resend);
      this.resendIn = Math.max(0, Math.round(seconds));
      if (this.resendIn === 0) return;
      this.timers.resend = setInterval(() => {
        this.resendIn -= 1;
        if (this.resendIn <= 0) {
          this.resendIn = 0;
          clearInterval(this.timers.resend);
        }
      }, 1000);
    },

    async submitLead() {
      if (this.$refs.gateForm && !this.$refs.gateForm.validate()) return;
      this.clearErrors();
      this.busy = true;
      try {
        const { data } = await axios.post('/auth/demo/lead', this.form);
        if (data.identified) {
          this.markIdentified();
          return;
        }
        this.form.email = data.email || this.form.email;
        this.code = '';
        this.step = 'code';
        this.startResendCountdown(data.resend_in || 60);
      } catch (err) {
        this.applyError(err);
      } finally {
        this.busy = false;
      }
    },

    async submitCode() {
      if (this.code.length !== 6) return;
      this.clearErrors();
      this.busy = true;
      try {
        const { data } = await axios.post('/auth/demo/verify', { code: this.code });
        // Ruhet pergjithmone ne kete shfletues: hyrjet e ardhshme ne demo
        // e dergojne dhe vizitori nuk pyetet me.
        if (data.device_token) localStorage.setItem('demo_device_token', data.device_token);
        this.markIdentified();
        if (this.$notify) this.$notify({ type: 'success', text: this.$t('demo.verified') });
        // Kerkesat e bllokuara gjate pritjes mbeten pezull; nje rifreskim i
        // ngarkon te dhenat e faqes pastër.
        setTimeout(() => window.location.reload(), 800);
      } catch (err) {
        this.applyError(err);
      } finally {
        this.busy = false;
      }
    },

    async resendCode() {
      this.clearErrors();
      this.busy = true;
      try {
        const { data } = await axios.post('/auth/demo/resend');
        if (data.identified) {
          this.markIdentified();
          return;
        }
        this.info = this.$t('demo.code_resent');
        this.startResendCountdown(data.resend_in || 60);
      } catch (err) {
        this.applyError(err);
      } finally {
        this.busy = false;
      }
    },

    editData() {
      this.clearErrors();
      this.code = '';
      this.step = 'form';
    },

    exitDemo() {
      this.stopTimers();
      localStorage.removeItem('demo_mode');
      localStorage.removeItem('demo_notice_pending');
      localStorage.removeItem('demo_identified');
      localStorage.setItem('freshToken', null);
      localStorage.setItem('userRole', null);
      this.$router.push('/login').catch(() => {});
      // Rifreskim i plote: pamjet e ngarkuara mbajne te dhena te demos ne memorie.
      setTimeout(() => window.location.reload(), 50);
    },
  },
};
</script>

<style scoped>
.demo-banner {
  /* Poshte, jo lart: siper do te mbulonte app-bar-in e Vuetify-t
     bashke me menune e perdoruesit dhe butonin e daljes. */
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 300;
  /* Vete shiriti eshte i tejdukshem dhe nuk kap klikimet; rreshtimi me
     karten e permbajtjes behet nga kutia e brendshme (pa-6 = 24px anash,
     boxed-container = max 1440px i centruar). */
  padding: 0 24px;
  pointer-events: none;
}

.demo-banner__inner {
  pointer-events: auto;
  max-width: 1440px;
  margin: 0 auto;
  height: 34px;
  background: #4f46e5;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.2);
}

/* Menuja anesore eshte 260px dhe rri e ngulitur nga 1264px e siper. Pa kete,
   shiriti nis nen te dhe teksti pritet. */
@media (min-width: 1264px) {
  .demo-banner {
    left: 260px;
  }
}

/* Ne telefon, pamja e prindit dhe e nxenesit kane nje shirit navigimi 68px te
   larte. Shiriti i demos rri mbi te, jo siper tij — perndryshe ua mbulon
   butonat. */
@media (max-width: 959px) {
  .demo-banner--mbi-shirit {
    bottom: calc(68px + env(safe-area-inset-bottom, 0px));
  }
}

.demo-banner__text {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.demo-banner__timer {
  margin-left: 10px;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.18);
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.demo-banner__exit {
  flex-shrink: 0;
  margin-left: 12px;
  background: rgba(255, 255, 255, 0.18) !important;
  color: #fff !important;
  font-size: 11px !important;
  letter-spacing: 0;
}

@media (max-width: 600px) {
  .demo-banner {
    padding: 0 12px;
  }
  .demo-banner__inner {
    font-size: 11px;
  }
}
</style>

<!-- Pa `scoped`: prek enen e permbajtjes, e cila i perket shtreses. -->
<style>
/* Shiriti i demos merr 34px poshte. Pa kete, fundi i faqes fshihet nen te —
   ne desktop gjithmone, ne telefon mbi shiritin e navigimit. */
/* Kodi 6-shifror lexohet me lehte i madh dhe i hapur. */
.demo-code-input input {
  font-size: 26px;
  letter-spacing: 0.35em;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

body.ka-shirit-demo .app-content-container {
  padding-bottom: 46px !important;
}

/* Aty ku ka edhe shirit navigimi, hapesira duhet te mbuloje te dyja. */
@media (max-width: 959px) {
  body.ka-shirit-demo.ka-shirit-nav .app-content-container {
    padding-bottom: calc(114px + env(safe-area-inset-bottom, 0px)) !important;
  }
}
</style>
